import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { MicWaveform } from './MicWaveform';
export function FinalCTA() {
  return <section id="final-cta" className="relative scroll-mt-16 overflow-hidden border-t border-slate-100 texture-dots py-24 lg:py-32" data-id="element-139">
      {/* Waveform that leans toward your cursor like a microphone */}
      <MicWaveform bars={64} className="pointer-events-none absolute inset-x-0 bottom-0 h-40 w-full justify-center lg:h-56" data-id="element-140" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-142">
          <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-teal-600" data-id="element-143">
            [ ready_when_you_are ]
          </p>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-6xl" data-id="element-144">
            Never <span className="text-teal-600" data-id="element-145">forget</span> another borrower
            conversation.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-slate-600" data-id="element-146">
            Recall is your desktop AI notetaker for every borrower call. Works
            with any dialer, organized by borrower, controlled by you.
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-147">
            <a href="https://github.com/Nimbus-Cloud-Solutions/recall-ai-install/releases/latest/download/Recall-Setup.exe" className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-lg bg-teal-600 px-6 py-3.5 text-base font-bold text-white hover:bg-teal-700 transition-colors" data-id="element-148">
              <DownloadIcon className="h-5 w-5" aria-hidden="true" data-id="element-149" />
              Download for Windows
              <span className="font-mono-brand ml-1 whitespace-nowrap rounded border border-white/30 bg-white/10 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-150">
                latest
              </span>
            </a>
          </div>
          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-500" data-id="element-151">
            <ShieldCheckIcon className="h-4 w-4 text-teal-600" aria-hidden="true" data-id="element-152" />
            User-controlled capture. Delete your data anytime.
          </p>
        </motion.div>
      </div>
    </section>;
}